import React, { useState , useCallback } from 'react';
import styled from 'styled-components';
import { Tabs, Tab as TabMui, Tooltip as TooltipMui } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { makeStyles, withStyles } from '@mui/styles';
import numeral from 'numeral';
//import { findIndex } from 'lodash';

const useStylesBootstrap = makeStyles((theme) => ({
  arrow: {
    color: '#d95d5f !important',
  },
  tooltip: {
    backgroundColor: '#d95d5f !important',
  },
}));

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#d95d5f',
    color: '#ffffff !important',
    maxWidth: 260,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #d95d5f',
  },
}))(TooltipMui);

const TAB = {
  'program': 'program',
  'time_period': 'time_period',
  'distribution': 'distribution',
  'donor_claim': 'donor_claim',
};

const TAB_POS = {
  'program': 1,
  'time_period': 2,
  'distribution': 3,
  'donor_claim': 4,
};

const TAB_QUESTION = {
  'program': 20001,
  'time_period': 20005,
  'distribution': 20007,
  'donor_claim': 20008,
};

/*
const TAB_REQUIRES_QUESTION = {
  "program": 20005,
  "time_period": 20005,
  "distribution": 20007,
  "donor_claim": 20008,
}*/

const TAB_LABEL = {
  'program': 'Program',
  'time_period': 'Time Period',
  'distribution': 'Distribution',
  'donor_claim': 'Donor Claim',
};

const Tooltip = ({ children, title }) => {
  const classes = useStylesBootstrap();
  return (
    <HtmlTooltip
      classes={classes}
      placement="top"
      PopperProps={{disablePortal: true}}
      open={!!title}
      title={title}
      disableFocusListener
      disableHoverListener
      disableTouchListener
      arrow
    >{children}</HtmlTooltip>);
};

const CBLabel = ({ label, checked }) => <span>
  {label} {(checked) ? <CheckGood><CheckIcon/></CheckGood> : <CheckEmpty/>} </span>;

const WizardHeader = ({ 
  donor = '-',
  claim = 0,
  contribution = 0,
  year = '2021',
  request = '-',
  designated_program = '-',
  tab,
  cachedQuestions = [],
  onPressTab = () => { /* noop */ },
  allocationAnswers
}) => {
  const [tabErrors, setTabErrors] = useState();

  const handlePressTab = useCallback((newValue) => {
    if (newValue === tab) return;
    const requestedTab = TAB_POS[newValue];
    const currentQuestionTab = TAB_POS[tab];
    const requestedQuestionKey = TAB_QUESTION[newValue];
    if (currentQuestionTab > requestedTab) {
      return onPressTab(TAB_QUESTION[newValue]);
    }
    if (allocationAnswers[requestedQuestionKey]) {
      return onPressTab(requestedQuestionKey);
    }
    setTabErrors(`You have pending question, please complete them before proceed to ${TAB_LABEL[newValue]}`);
    setTimeout(() => {
      setTabErrors();
    }, 2000);
  }, [onPressTab, tab, allocationAnswers]);

  return (
    <Header>
      <Row>
        <Table>
          <TRow>
            <TCol>
              <span className="r-title">Donor:</span>
              <span className="r-donor">{donor}</span>
            </TCol>
            <TCol>
              <span className="r-title">Contribution:</span>
              <span className="r-sub">{`$${numeral(contribution).format(0, 0)} TOTAL FOR ${year}`}</span>
            </TCol>
          </TRow>
          <TRow>
            <TCol>
              <span className="r-title">Designated program:</span>
              <span className="r-sub">{designated_program}</span>
            </TCol>
          </TRow>
        </Table>
      </Row>
      <Tooltip title={tabErrors}>
      <StyledTabs id="tabs" value={tab}>
        <Tab onClick={() => handlePressTab(TAB.program)} value={TAB.program} label={<CBLabel label="Program" checked={TAB_POS[tab] > 1}/>}/>
        <Tab
          onClick={() => handlePressTab(TAB.time_period)}
          value={TAB.time_period}
          label={<CBLabel label="Time Period" checked={TAB_POS[tab] > 2}/>}
        />
        <Tab
          onClick={() => handlePressTab(TAB.distribution)}
          value={TAB.distribution}
          label={<CBLabel label="Distribution" checked={TAB_POS[tab] > 3}/>}
        />
        <Tab
          onClick={() => handlePressTab(TAB.donor_claim)}
          value={TAB.donor_claim}
          label={<CBLabel label="Donor Claim" checked={TAB_POS[tab] > 4} />}
        />
      </StyledTabs>
      </Tooltip>
    </Header>
  );
};
export const Header = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #ebf0f6;
  padding: 20px;
  padding-top: 0px;
  padding-bottom: 0px;
  span.r-title {
    color: #595959;
    font-size: 14px;
    font-weight: 700;
  }
  span.r-donor {
    color: #595959;
    font-size: 15px;
    font-weight: 700;
  }
  span.r-sub {
    color: #99ACC2;
    font-size: 15px;
    font-weight: 700;
  }
  .MuiChip-root {
    background-color: #595959;
    border: none;
    color: #ffffff;
    svg {
      display: none;
    }
  }
  div#tabs.MuiTabs-root {
    background-color: transparent !important;
    min-height: 40px !important;
    div.MuiTabs-scroller {
      background-color: transparent !important;
      div.MuiTabs-flexContainer {
        height: 100%;
      }
      .MuiButtonBase-root {
        padding: 6px !important;
        min-width: 100px !important;
        display: block !important;
        min-height: 40px !important;
        span {
          font-size: 14px;
        }
      }
    }
  }
`;
export const Row = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
export const Table = styled.div `
  width: 100%;
  min-height: 20px;
  background-color: #ffffff;
  border: solid 1px #CBD6E2;
  border-radius: 3px;
  margin-bottom: 16px;
`;
export const TRow = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  :last-of-type {
    border-top: solid 1px #CBD6E2;
  }
`;
export const TCol = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 8px;
  :last-of-type {
    border-left: solid 1px #CBD6E2;
  }
`;
export const StyledTabs = styled(Tabs)`
  background-color: transparent !important;
  div.MuiTabs-scroller {
    background-color: transparent !important;
  }
  .MuiSelected {
    color: #0072A2 !important;
    span.MuiTab-wrapper{
      color: #0072A2 !important;
    }
  }
  span.MuiTabs-indicator {
    display:none;
  }
`;
export const Tab = styled(TabMui)`
  cursor: inherit !important;
  color: #48596B !important;
  font-size: 14px !important;
  font-weight: 700 !important;
  background-color: transparent !important;
  &.Mui-selected {
    background-color: #FFFFFF !important;
    color: #0072A2 !important;
    border-top: solid 2px #0072A2;
    border-bottom: none;
    span.MuiTab-wrapper{
      color: #0072A2 !important;
    }
    :hover {
      background-color: #FFFFFF !important;
    }
  }
  span {
    text-transform: none;
  }
  span.MuiTab-wrapper {
    display: inline-block !important;
  }
`;

const baseSmallIcon = styled.div`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  text-align: center;
  box-sizing: border-box;
  svg {
    color: white;
    font-size: 10px;
  }
`;

export const CheckGood = styled(baseSmallIcon)`
  border: solid 1px #00AA72;
  background-color: #00AA72;
`;

export const CheckEmpty = styled(baseSmallIcon)`
  border: solid 1px #595959;
  background-color: transparent;
`;

export default WizardHeader;

